<template>
  <div class="CompanyCustomCase">
    <div class="inner_center">
      <h2>获取企业定制授权方案</h2>

      <div class="subhead">
        留下您的信息，我们会为您提供更贴心、合适的企业定制方案
      </div>

      <div class="form-wrap">
        <div class="form-item">
<!--          <div class="form-item-label">咨询类型</div>-->
          <input
            v-model="form.nickname"
            type="text"
            placeholder="请输入您的称呼（必填）"
            @blur="verifyNiceName"
            @input="changeNiceName"
          >
          <i
            v-if="form.nickname !== ''"
            class="iconfont icon-cha"
            @click="form.nickname = ''"
          />
          <div class="err-msg">{{ nicknameErrMsg }}</div>

        </div>
        <div class="form-item">
          <input
            v-model="form.companyName"
            type="text"
            placeholder="请输入企业名称（必填）"
            @blur="verifyCompanyName"
            @input="changeCompanyName"
          >
          <i
            v-if="form.companyName !== ''"
            class="iconfont icon-cha"
            @click="form.companyName = ''"
          />
          <div class="err-msg">{{ companyNameErrMsg }}</div>
        </div>
        <div class="form-item">
          <input
            v-model="form.phone"
            type="text"
            placeholder="请输入手机号码（必填）"
            @blur="verifyIphone"
            @input="changeIPhone"
          >
          <i
            v-if="form.phone !== ''"
            class="iconfont icon-cha"
            @click="form.phone = ''"
          />
          <div class="err-msg">{{ phoneErrMsg }}</div>
        </div>
        <div class="form-item">
          <input
            v-model="form.code"
            type="text"
            placeholder="请输入验证码（必填）"
            @blur="verifyCode"
            @input="changeCode"
          >
          <i
            v-if="form.code !== ''"
            class="iconfont icon-cha"
            @click="form.code = ''"
          />
          <div class="get-code" @click="getCode">{{ codeText }}</div>
          <div class="err-msg">{{ codeErrMsg }}</div>

        </div>
      </div>

      <div id="nc3"></div>

      <div class="submit-btn" @click="submit">
        提交获取方案
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import {submitCompanyCustom} from "@/api/company";
import myNotify from "@/utils/notify";
import {getCode} from "@/api/login";

export default {
  name: "CompanyCustomCase",
  data() {
    return {
      form: {
        nickname: '',
        companyName: '',
        phone: '',
        code: ''
      },
      nicknameErrMsg: '', // 请输入您的称呼
      companyNameErrMsg: '', // 请输入企业名称
      phoneErrMsg: '', // 请输入手机号码
      codeErrMsg: '',  // 请输入验证码
      codeText: '获取验证码',
      verifyStatus: false,

      countdownTime: 60,
      downTimeStatus: true,
      codeForm: {
        sessionId: undefined,
        sig: undefined,
        token: undefined,
        scene: undefined,
      }
    }
  },
  mounted() {
    this.initHuaKuai();
  },

  methods: {
    verifyNiceName() {
      let trimVal = this.$utils.string.trim(this.form.nickname);
      console.log(trimVal)
      this.nicknameErrMsg = trimVal.length == 0 ? '请输入您的称呼' : '';
      return trimVal.length !== 0;
    },

    changeNiceName() {
      this.form.nickname = this.$utils.string.trim(this.form.nickname);
      if (this.form.nickname.length) {
        this.nicknameErrMsg = '';
      }
    },

    verifyCompanyName() {
      let trimVal = this.$utils.string.trim(this.form.companyName);
      this.companyNameErrMsg = trimVal.length == 0 ? '请输入企业名称' : '';
      return trimVal.length !== 0;
    },
    changeCompanyName() {
      this.form.companyName = this.$utils.string.trim(this.form.companyName);
      if (this.form.companyName.length) {
        this.companyNameErrMsg = '';
      }
    },

    verifyIphone() {
      let temp = this.$utils.verify.iphone(this.form.phone);
      let clues = ["请输入手机号", "", "手机号格式不正确"];
      console.log(temp.status)
      this.phoneErrMsg = clues[temp.status];
      this.verifyStatus = temp.status === 1;
      return temp.status === 1;
    },

    changeIPhone() {
      this.form.phone = this.$utils.string.trim(this.form.phone);
      if (this.form.phone.length) {
        this.phoneErrMsg = '';
      }
    },


    verifyCode() {
      let bool = !(this.form.code === '');
      let clues = ["请输入验证码", ""];
      this.codeErrMsg = clues[Number(bool)];
      this.verifyStatus = bool;
      return bool
    },
    changeCode() {
      if (this.form.code.length > 0) {
        this.codeErrMsg = '';
      }
    },


    getCode: _.throttle(function () {

      /*this.verifyNiceName();
      this.verifyCompanyName();
      this.verifyIphone();
      this.verifyCode();*/
      // this.verifyIphone();

      let temp = this.$utils.verify.iphone(this.form.phone);
      let clues = ["请输入手机号", "", "手机号格式不正确"];
      if (temp.status != 1){
        this.$myNotify.error(clues[temp.status])
        this.phoneErrMsg = clues[temp.status];
        this.verifyStatus = temp.status === 1;
        return false
      }

      /* 验证滑块 */
      if (this.codeForm.sessionId == undefined) {
        this.$myNotify.error('请先进行滑块验证')
        return false
      }

      if (this.verifyStatus && this.downTimeStatus) {
        this.$utils.time.countdown(this.countdownTime, 60, time => {
          this.downTimeStatus = false;
          this.codeText = `${time}秒后再试`
        }).then(r => {
          this.codeText = `获取验证码`;
          this.downTimeStatus = true;
        })
        /*this.$store.dispatch("user/GetVerificationCode", this.iphone)
          .then(res => {
            let {info, status} = res.data;
            if (status !== 1) {
              this.verifyCodeClues = info;
            }
          })
          .catch(err => {

          });*/
        let params = Object.assign({ phone: this.form.phone, act: 'apply', },this.codeForm)

        getCode(params).then(res => {
          let response = res.data;
          let msg = response.status === 1 ? '发送成功' : `${response.info}`;

          if (response.status === 1) {
            myNotify.success(msg);
          } else{
            myNotify.error(msg);
            window.nc3.reset()
          }
        }).catch(error => {
          myNotify.error(`发送失败，请稍后重试`);
        })
      }
    }, 2000),


    submit:_.throttle(function () {
      this.verifyNiceName();
      this.verifyCompanyName();
      this.verifyIphone();
      this.verifyCode();

      let where = this.verifyNiceName() && this.verifyCompanyName() && this.verifyIphone() && this.verifyCode()
      if (where) {
        console.log('校验成功')
        console.log(this.form)


        let params = Object.assign(this.codeForm,this.form)

        submitCompanyCustom(this.form).then(res => {
          console.log(res)
          /*if (res.data.status === 0) {
            this.$myNotify.error(`提交失败，请稍后重试`);
          } else {
            this.$myNotify.success(`提交成功`, () => {
              this.clearForm();
            }, 2000);
          }*/
          let { status,msg } = res.data;
          if (status === 1) {
            this.$myNotify.success(`提交成功`, () => {
              this.clearForm();
            }, 2000);
          }else if (status === -1){
            this.$myNotify.error(`验证码错误`,()=>{},2000);
          }else{
            this.$myNotify.error(msg);
          }
        }).catch(err => {

        })
      } else {
        console.log('校验失败')
      }

    }, 2000),


    clearForm() {
      this.form = {
        nickname: '',
        companyName: '',
        phone: ''
      }

      this.nicknameErrMsg = '';
      this.companyNameErrMsg = '';
      this.phoneErrMsg = '';
      this.codeText = '获取验证码'
    },


    initHuaKuai() {
      let _this = this;

      AWSC.use("nc", function (state, module) {
        // 初始化
        window.nc3 = module.init({
          // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          appkey: "FFFF0N0000000000638F",
          //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
          scene: "nc_login",
          // 声明滑动验证需要渲染的目标ID。
          renderTo: "nc3",
          width: 340,
          //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
          success: function (data) {
            let {sessionId, sig, token} = data
            _this.codeForm = {
              sessionId,
              sig,
              token,
              scene: 'nc_login',
            }
          },
          // 滑动验证失败时触发该回调参数。
          fail: function (failCode) {
            window.console && console.log(failCode)
          },
          // 验证码加载出现异常时触发该回调参数。
          error: function (errorCode) {
            window.console && console.log(errorCode)
          }
        });
      })
    },

  }
}
</script>

<style lang="scss" scoped>
.CompanyCustomCase {
  @include BgImage(100%, 521px, 'introduce/company/CustomCase/CompanyCustomCase.jpg', 1);

  .inner_center {
    width: 1200px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  h2 {
    letter-spacing: 1px;
    margin: 56px 0 12px;

    font-size: 32px;
    font-weight: bold;
    color: #FFD0AC;
    line-height: 42px;
  }

  .subhead {
    letter-spacing: 1px;
    margin-bottom: 56px;
    font-size: 14px;
    color: #FFD0AC;
    line-height: 19px;

  }

  .form-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .form-item {
      width: 340px;
      height: 48px;
      line-height: 48px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.8);
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      margin-bottom: 62px;
      position: relative;
      margin-right: 80px;



      &:last-child {
        //margin-bottom: 46px;

        input {
          width: 60%;
        }

        .icon-cha {
          right: 30%;
        }
      }

      &:nth-child(2n) {
        //margin-right: 0;
      }

      input {
        width: 308px;
        box-sizing: border-box;
        padding: 0 0px 0 16px;
        color: #FFFFFF;
        line-height: 20px;

        &::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }
      }

      .icon-cha {
        @include Position(1, 2, 15px, 50%);
        transform: translateY(-50%);
        cursor: pointer;
        font-size: 12px;
        @include ElementHover(#FFFFFF, '');
      }

      .get-code {
        @include Position(1, 2, 15px, 50%);
        transform: translateY(-50%);
        cursor: pointer;
        @include ElementHover(#FFFFFF, '');
      }

      .err-msg {
        @include Position(1, 4, 15px, -22px);
        font-size: 12px;
        color: #EE5253;
        line-height: 16px;
      }
    }
  }

  .submit-btn {
    width: 340px;
    height: 54px;
    line-height: 54px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #2E3351;
    background: linear-gradient(51deg, #F5D9C3 0%, #E8BF97 100%);
    border-radius: 27px;

    @include ElementHover('', '') {
      background: linear-gradient(51deg, #E8BF97 0%, #F4DCBA 100%);
    }
  }

}

#nc3{
  position: relative;
  margin: -20px auto 20px;
  width: 340px;
}
</style>
